export default __webpack_public_path__ + "static/media/image16.65f76a1d.png";